import React, { createContext, useContext } from 'react';
import useFileNavigation from '../hooks/useFileNavigation';

// Create the context
const FileNavigationContext = createContext(null);

/**
 * Provider component for file navigation state
 * Makes navigation state and methods accessible throughout the app
 */
export const FileNavigationProvider = ({ children }) => {
  // Use the hook to get navigation state and methods
  const navigationState = useFileNavigation();

  return <FileNavigationContext.Provider value={navigationState}>{children}</FileNavigationContext.Provider>;
};

/**
 * Hook to consume the file navigation context
 * Use this in components that need access to the shared navigation state
 */
export const useFileNavigationContext = () => {
  const context = useContext(FileNavigationContext);

  if (!context) {
    throw new Error('useFileNavigationContext must be used within a FileNavigationProvider');
  }

  return context;
};

export default FileNavigationContext;
